<template>
    <div id="Stats">
        <div class="box" id="title">
            <h1 class="title has-text-grey-dark"><i class="fa fa-gift"></i><span style="margin-left: 10px;">Magic Ears StandBy Lifesaver 2.0</span></h1>
            <p class="subtitle">Real Heroes Don't Wear Capes</p>
        </div>
        <!--<hr>-->
        <div class="box">
            <div class="columns is-multiline" v-if="!loading">
                <div class="column is-offset-4 is-4-fullhd is-4-widescreen is-12-mobile is-4-tablet">
                    <div class="field">
                        <span class="heading has-text-grey-dark">Find Lesson
                            <a class="is-link is-pulled-right tooltip is-tooltip-multiline is-tooltip-top" data-tooltip="Search by Lesson ID Number or Lesson Name (ex. 1-1-1 or Alphabet AB)"><i class="fa fa-question-circle is-size-5"></i></a>
                        </span>
                        <search-select
                                       ref="searchLessonSelect"
                                       label="search"
                                       placeholder="e.g. 1-1-1 or L1-U1-L1 or Alphabet AB"
                                       :selected="lesson"
                                       optionLabel="name"
                                       :loading="searchLesson"
                                       @change="onLessonChanged"
                                       @type="onLessonType">
                        </search-select>
                        <!--:items="lessons"-->
                        <span class="help is-danger">{{ lessonError }}</span>
                    </div>
                </div>
            </div>

            <div class="columns is-multiline" v-if="!showPanel">
                <div class="column is-4 is-offset-4">
                    <div class="columns is-multiline">
                        <div  class="column is-12">
                            <a class="button is-primary is-fullwidth" @click="newLesson()">
                                <span class="icon">
                                  <i class="fa fa-add"></i>
                                </span>
                                <span>Add New Lesson</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns is-multiline" v-if="!loading && lessons && lessons.length > 1">
                <div class="column is-4 is-offset-4">
                    <div class="columns is-multiline">
                        <div class="column is-12">
                            <span class="heading has-text-grey-dark">Choose Version</span>
                            <multiselect visible="auto" v-model="lesson" label="name" name="lessons" track-by="id" :show-labels="false" :options="lessons" :multiple="false" :custom-label="customLabel" placeholder="Choose lesson"></multiselect>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns is-multiline" v-if="!loading && lesson.id != null">
                <div class="column is-4 is-offset-4">
                    <div class="columns is-multiline">
                        <div v-if="!editing" class="column is-12">
                            <a v-if="!editing" class="button is-primary is-fullwidth" @click="change()">
                                <span class="icon">
                                  <i class="fa fa-edit"></i>
                                </span>
                                <span>Revise Lesson Info</span>
                            </a>
                        </div>
                        <div v-if="editing" class="column is-6">
                            <a class="button is-primary is-fullwidth" @click="save()">
                                <span class="icon">
                                      <i class="fa fa-save"></i>
                                    </span>
                                <span>Save</span>
                            </a>
                        </div>
                        <div v-if="editing" class="column is-6">
                            <a class="button is-danger is-fullwidth" @click="discard()">
                                <span class="icon">
                                      <i class="fa fa-ban"></i>
                                    </span>
                                <span>Discard</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns is-multiline" v-if="showPanel">
                <div class="column is-4 is-offset-4">
                    <div class="box notification p20 is-info">
                        <div v-if="!editing" class="title has-text-centered">{{lesson.additionalInfo.name}}</div>
                        <div v-else class="field">
                            <div class="control">
                                <input type="text" class="input" v-model="lessonChanged.additionalInfo.name" name="name"  v-validate="'required'" placeholder="Lesson Name">
                                <transition name="fade-fast">
                                    <span v-show="errors.has('name')" class="help is-danger">The Lesson Name field is required.</span>
                                </transition>
                            </div>
                        </div>
                        <div  v-if="!editing" class="heading has-text-centered">{{lesson.additionalInfo.provider_full_id}}</div>
                        <div v-else class="field">
                            <!--<label class="label">Lesson ID</label>-->
                            <div class="control">
                                <input type="text" class="input" v-model="lessonChanged.additionalInfo.provider_full_id" name="provider_full_id"  v-validate="'required'" placeholder="Lesson ID">
                                <transition name="fade-fast">
                                    <span v-show="errors.has('provider_full_id')" class="help is-danger">The Lesson ID field is required.</span>
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns is-multiline" v-if="!loading && lesson.id != null">
                <div class="column">
                    <div class="box notification p20 is-primary">
                        <div class="title"><i class="fa fa-book"></i> Target Vocabulary</div>
                        <div class="columns is-multiline is-primary">
                            <div class="column is-6-fullhd is-12-mobile is-12-tablet">
                                <div class="card" v-scroll-to="'#tabs'">
                                    <header class="card-header is-size-5">
                                        <p class="card-header-title">Let's Practice Words</p>
                                    </header>
                                    <div class="card-content max-height-250">
                                        <div class="content has-text-justified">
                                            <p v-if="!editing" class="has-text-grey-dark fs22">{{lesson.additionalInfo.practice_words}}</p>
                                            <div v-else class="field">
                                                <div class="control">
                                                    <textarea class="textarea" v-model="lessonChanged.additionalInfo.practice_words" name="practice_words"  v-validate="'required'"></textarea>
                                                    <transition name="fade-fast">
                                                        <span v-show="errors.has('practice_words')" class="help is-danger">The Let's Practice Words field is required.</span>
                                                    </transition>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-6-fullhd is-12-mobile is-12-tablet">
                                <div class="card" v-scroll-to="'#tabs'">
                                    <header class="card-header is-size-5">
                                        <p class="card-header-title">Other key words</p>
                                    </header>
                                    <div class="card-content max-height-250">
                                        <div class="content has-text-justified">
                                            <p v-if="!editing" class="has-text-grey-dark fs22">{{lesson.additionalInfo.other_key_words}}</p>
                                            <div v-else class="field">
                                                <div class="control">
                                                    <textarea class="textarea" v-model="lessonChanged.additionalInfo.other_key_words" name="other_key_words"  v-validate="'required'"></textarea>
                                                    <transition name="fade-fast">
                                                        <span v-show="errors.has('other_key_words')" class="help is-danger">The Other key words field is required.</span>
                                                    </transition>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="box notification p20 is-warning">
                        <div class="title"> <i class="fa fa-gamepad"></i> Games and Role Play</div>
                            <div class="columns is-multiline is-primary">
                                <div class="column is-6-fullhd is-12-mobile is-12-tablet">
                                    <div class="card" v-scroll-to="'#tabs'">
                                        <header class="card-header is-size-5">
                                            <p class="card-header-title">Role Play Slides</p>
                                        </header>
                                        <div class="card-content max-height-250">
                                            <div class="content has-text-justified">
                                                <p v-if="!editing" class="has-text-grey-dark fs22">{{lesson.additionalInfo.role_play_slides}}</p>
                                                <div v-else class="field">
                                                    <div class="control">
                                                        <textarea class="textarea" v-model="lessonChanged.additionalInfo.role_play_slides" name="role_play_slides"  v-validate="'required'"></textarea>
                                                        <transition name="fade-fast">
                                                            <span v-show="errors.has('role_play_slides')" class="help is-danger">The Role Play Slides field is required.</span>
                                                        </transition>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-6-fullhd is-12-mobile is-12-tablet">
                                    <div class="card" v-scroll-to="'#tabs'">
                                        <header class="card-header is-size-5">
                                            <p class="card-header-title">Let's Play Slide (game)</p>
                                        </header>
                                        <div class="card-content max-height-250">
                                            <div class="content has-text-justified">
                                                <p v-if="!editing" class="has-text-grey-dark fs22">{{lesson.additionalInfo.game}}</p>
                                                <div v-else class="field">
                                                    <div class="control">
                                                        <textarea class="textarea" v-model="lessonChanged.additionalInfo.game" name="game"  v-validate="'required'"></textarea>
                                                        <transition name="fade-fast">
                                                            <span v-show="errors.has('game')" class="help is-danger">The Let's Play Slide (game) field is required.</span>
                                                        </transition>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            <div class="columns is-multiline" v-if="!loading && lesson.id != null">
                <div class="column">
                    <div class="box notification p20 is-black">
                        <div class="title"><i class="fa fa-music"></i> Props and Songs</div>
                        <div class="columns is-multiline is-primary">
                            <div class="column is-6-fullhd is-12-mobile is-12-tablet">
                                <div class="card" v-scroll-to="'#tabs'">
                                    <header class="card-header is-size-5">
                                        <p class="card-header-title">Prop Ideas</p>
                                    </header>
                                    <div class="card-content max-height-250">
                                        <div class="content has-text-justified">
                                            <p v-if="!editing" class="has-text-grey-dark fs22">{{lesson.additionalInfo.prop_ideas}}</p>
                                            <div v-else class="field">
                                                <div class="control">
                                                    <textarea class="textarea" v-model="lessonChanged.additionalInfo.prop_ideas" name="prop_ideas"  v-validate="'required'"></textarea>
                                                    <transition name="fade-fast">
                                                        <span v-show="errors.has('prop_ideas')" class="help is-danger">The Prop Ideas field is required.</span>
                                                    </transition>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-6-fullhd is-12-mobile is-12-tablet">
                                <div class="card" v-scroll-to="'#tabs'">
                                    <header class="card-header is-size-5">
                                        <p class="card-header-title">Ending song length</p>
                                    </header>
                                    <div class="card-content max-height-250">
                                        <div class="content has-text-justified">
                                            <p v-if="!editing" class="has-text-grey-dark fs22">{{lesson.additionalInfo.ending_song_length}}</p>
                                            <div v-else class="field">
                                                <div class="control">
                                                    <textarea class="textarea" v-model="lessonChanged.additionalInfo.ending_song_length" name="ending_song_length"  v-validate="'required'"></textarea>
                                                    <transition name="fade-fast">
                                                        <span v-show="errors.has('ending_song_length')" class="help is-danger">The Ending song length field is required.</span>
                                                    </transition>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="box notification p20 is-success">
                        <div class="title"> <i class="far fa-clock"></i> Show Time and Crown Page</div>

                        <div class="columns is-multiline is-primary">
                            <div class="column is-6-fullhd is-12-mobile is-12-tablet">
                                <div class="card" v-scroll-to="'#tabs'">
                                    <header class="card-header is-size-5">
                                        <p class="card-header-title">Show time?</p>
                                    </header>
                                    <div class="card-content max-height-250">
                                        <div class="content has-text-justified">
                                            <p v-if="!editing" class="has-text-grey-dark fs22">{{lesson.additionalInfo.show_time}}</p>
                                            <div v-else class="field">
                                                <div class="control">
                                                    <textarea class="textarea" v-model="lessonChanged.additionalInfo.show_time" name="show_time"  v-validate="'required'"></textarea>
                                                    <transition name="fade-fast">
                                                        <span v-show="errors.has('show_time')" class="help is-danger">The Show time field is required.</span>
                                                    </transition>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-6-fullhd is-12-mobile is-12-tablet">
                                <div class="card" v-scroll-to="'#tabs'">
                                    <header class="card-header is-size-5">
                                        <p class="card-header-title">Crown Page?</p>
                                    </header>
                                    <div class="card-content max-height-250">
                                        <div class="content has-text-justified">
                                            <p v-if="!editing" class="has-text-grey-dark fs22">{{lesson.additionalInfo.crown_page}}</p>
                                            <div v-else class="field">
                                                <div class="control">
                                                    <textarea class="textarea" v-model="lessonChanged.additionalInfo.crown_page" name="crown_page"  v-validate="'required'"></textarea>
                                                    <transition name="fade-fast">
                                                        <span v-show="errors.has('crown_page')" class="help is-danger">The Crown Page field is required.</span>
                                                    </transition>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns content">

            </div>
            <p v-if="!loading && lesson.id == null">Time is of the essence when answering the StandBy Call and with this tool we aim to help all Heroes who volunteer for entering the class without adequate time to prepare. For now, this tool is available only to Magic Ears Teachers, to learn how to utilize it effectively please watch the <a href="https://www.youtube.com/watch?v=0MubAyD0Ggw" target="_blank"> Tutorial first.</a></p>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'

export default {
  name: 'stby',
  data() {
        return {
            loading: false,
            saving: false,
            stats: {},
            lessons:[],
            searchLesson:false,
            lessonError: null,
            lesson : {id:null, search:"", additionalInfo:{provider_full_id:'', name:''}},
            lessonChanged : {id:null, search:"", additionalInfo:{provider_full_id:'', name:''}},
            editing : false,
            adding : false,
        }
  },
  created(){
  },
  mounted(){

  },
  methods: {
      onLessonChanged(lesson){
          this.setLesson(lesson);
      },
      onLessonType(q){
          if(q && q.length >= 4 && q !== this.lesson.search){
              this.lesson.search = q;
              //this.findLesson();
          }
      },
      findLesson(){
        this.searchLesson = true;
        this.lessonError = null;
        this.lessons = [];
        this.stbyLessonRepo.search({ query:this.lesson.search, school_id:this.MAGIC_EARS.id}).then((response) => {
            let resp = response.data.data;
            let self = this;
            if(resp.length > 0){
                resp.forEach(function ($el) {
                    $el.search = self.lesson.search;
                });
            }
            if(resp.length === 0){
                this.lessonError = "Lesson Not Found ~ Try using the suggested format (e.g. 1-1-1 or L1-U1-L1 or Alphabet AB)";
                this.lessons = [];
                this.lesson.id = null;
            } else{
                this.lessons = resp;
                this.setLesson(resp[0]);
            }
            this.searchLesson = false;
        }).catch((response) => {
            this.lessonError = "Lesson Not Found ~ Try using the suggested format (e.g. 1-1-1 or L1-U1-L1 or Alphabet AB)";
            this.lessons = [];
        }).finally(() => {
            this.searchLesson = false;

        });
      },

      change() {
          this.editing = true;
          this.lessonChanged = Object.assign({}, this.lesson);
          this.lessonChanged.school_id = this.MAGIC_EARS.id;
      },
      newLesson(){
          this.editing = true;
          this.lesson.id = -1;
          this.lessonChanged.name = '';
          this.lessonChanged.id = '';
          this.lessonChanged.school_id = this.MAGIC_EARS.id;
          this.lessonChanged.provider_id = '';
          this.lessonChanged.additionalInfo = {};
          this.lessonChanged.additionalInfo.name = '';
          this.lessonChanged.additionalInfo.provider_full_id = '';

      },
      save() {
          this.$validator.validateAll().then((result) => {
              if (result) {
                  this.loading = true;
                  //console.log(this.lessonChanged);
                  this.stbyLessonRepo.store(this.lessonChanged).then(response => {
                      this.$toast.info(response.data.message);
                      this.editing = false;
                      this.lesson.id = this.lesson.id !=-1 ? this.lesson.id : null;
                  }).catch((response) =>{
                      return Promise.reject(response);
                  }).finally(() => {
                      this.loading = false;
                      //this.editing = false;
                  });
              }
          });
      },
      discard(){
          this.editing = false;
          if(this.lesson.id == -1){
              this.lesson.id = null;
          }
      },
      customLabel(item) {
          return item.name + ' (' + item.provider_id +')'
      },

      setLesson(lesson){
          //console.log('setLesson');
          this.lesson = Object.assign({}, lesson);
          this.lesson.additionalInfo.provider_full_id = this.lesson.additionalInfo.provider_full_id =='' ? this.lesson.provider_id : this.lesson.additionalInfo.provider_full_id;
          this.lesson.additionalInfo.name = this.lesson.additionalInfo.name =='' ? this.lesson.name : this.lesson.additionalInfo.name;
      }

     
  },
    watch: {
        'lesson.search':_.debounce(function(value){
            if(value && value.length > 0){
                this.findLesson();
            }
        }, 800),

        'lesson'(value){
            if(!value.additionalInfo){
                this.lesson.additionalInfo = this.meDefaultAdditionalInfo();
            };
            this.lesson.additionalInfo.provider_full_id = this.lesson.additionalInfo.provider_full_id =='' ? this.lesson.provider_id : this.lesson.additionalInfo.provider_full_id;
            this.lesson.additionalInfo.name = this.lesson.additionalInfo.name =='' ? this.lesson.name : this.lesson.additionalInfo.name;
            this.lessonChanged = Object.assign({}, this.lesson);
            this.lessonChanged.school_id = this.MAGIC_EARS.id;
            //this.change();
        },

    },
    computed: {
        showPanel() {
            return (!this.loading && this.lesson.id != null);
        },
    }
  
}
</script>

<style lang="css" scoped>

    .min-height-100{
        min-height: 100px;
        height: fit-content;
    }

    .p20{
        padding: 20px;
    }

    .fs22{
        font-size: 22px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/STBY/MELessons.vue